import { RecentlyViewed16 } from '@carbon/icons-react';
import { Divider as AntdDivider } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
// import { CustomerPortalButtonType } from 'api/customer-portal/theme-api';
import { ReactComponent as Folder16 } from 'assets/svgs/folder-filled.svg';
import { ReactComponent as SpotlightSvg } from 'assets/svgs/spotlight.svg';
import {
  CpBody00Secondary,
  CpBody01Secondary,
} from 'components/atoms/customer-portal/typography';
import { ALL_COLORS_WITHOUT_GRAY, Color } from 'components/colors';
import { useIsTablet } from 'hooks/use-media-query';
import { getRandomColor } from 'utils/get-random-color';
// import { CpButton } from '../../components/cp-button';
import { CpSpaceProps, RECENTS_FOLDER_ID, SPOTLIGHT_FOLDER_ID } from './types';

// const AddButtonWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: var(--cp-spacing-05);
// `;

// const AddButton = styled(CpButton)`
//   width: 100%;
// `;

const Folder = styled.div<{
  active?: boolean;
  noHover?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--cp-spacing-05);
  padding-left: var(--cp-spacing-07);
  @media (max-width: 480px) {
    padding-left: var(--cp-spacing-05);
  }

  .cp-very-light-background &:hover {
    background: var(--cp-background-as-black-opacity-02);
  }

  ${(props) =>
    props?.noHover
      ? css``
      : css`
          :hover {
            background: var(--cp-background-as-white-opacity-02);
          }
          .cp-very-light-background &:hover {
            background: var(--cp-background-as-black-opacity-02);
          }
        `};
  ${(props) =>
    props.active
      ? css`
          background: var(--cp-background-as-white-opacity);

          .cp-very-light-background & {
            background: var(--cp-background-as-black-opacity);
          }
        `
      : css``};
`;
const FolderIcon = styled.div<{ color?: Color }>`
  min-width: 32px;
  /* min-height: 32px; */
  width: 32px;
  /* height: 32px; */
  margin-right: var(--cp-spacing-03);
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.color
      ? css`
          svg {
            fill: var(--cp-${props.color}-60);
          }
        `
      : css``};
`;

const SpotlightFolderIcon = styled(FolderIcon)`
  svg {
    fill: var(--cp-orange-40);
  }
`;

const FolderName = styled(CpBody01Secondary)`
  margin-bottom: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SectionTitle = styled(CpBody00Secondary)`
  margin-bottom: 0;
`;

const Sidebar = styled.div`
  width: 300px;
  height: 100%;
  background-color: var(--cp-background-as-white-opacity);
  padding-bottom: var(--cp-spacing-06);
  padding-top: var(--cp-spacing-06);

  overflow-y: auto;

  @media (min-width: 769px) {
    border-right: 1px solid var(--cp-border-subtle);
  }

  @media (max-width: 480px) {
    border: 1px solid var(--cp-border-subtle);
  }

  @media (max-width: 768px) {
    width: 100%;
    border-radius: var(--border-radius-small);
  }
`;

const Divider = styled(AntdDivider)`
  margin: var(--cp-spacing-05) 0;
  border-color: var(--cp-border-subtle-auto-adjust);
`;

export const CpSpacesSidePane: React.FC<
  Pick<CpSpaceProps, 'search' | 'currentSpace' | 'onSpaceClick' | 'data'>
> = ({ search, currentSpace, onSpaceClick, data }) => {
  const isResponsive = useIsTablet();

  const content = (
    <Sidebar>
      {/* <AddButtonWrapper>
      <AddButton
        cpType={CustomerPortalButtonType.Primary}
        icon={<Add16 />}
      >
        <FormattedMessage id="new" />
      </AddButton>
    </AddButtonWrapper> */}
      <Folder
        active={currentSpace?.spaceId === SPOTLIGHT_FOLDER_ID}
        onClick={() => onSpaceClick('spotlight')}
      >
        <SpotlightFolderIcon>
          <SpotlightSvg />
        </SpotlightFolderIcon>
        <FolderName>
          <FormattedMessage id="spotlight" />
        </FolderName>
      </Folder>
      <Folder
        active={currentSpace?.spaceId === RECENTS_FOLDER_ID}
        onClick={() => onSpaceClick('recents')}
      >
        <FolderIcon>
          <RecentlyViewed16 />
        </FolderIcon>
        <FolderName>
          <FormattedMessage id="recents" />
        </FolderName>
      </Folder>

      <Divider />

      <Folder noHover>
        <SectionTitle>
          <FormattedMessage id="projects.tabs.spaces" />
        </SectionTitle>
      </Folder>

      {data?.spaces?.map((sp) => {
        if (
          isResponsive &&
          !!search?.trim() &&
          !sp.spaceName.toLowerCase().includes(search.toLowerCase())
        ) {
          return <></>;
        }

        return (
          <Folder
            active={currentSpace?.spaceId === sp.spaceId}
            key={sp.spaceId}
            onClick={() => onSpaceClick(sp.spaceId)}
          >
            <FolderIcon
              color={getRandomColor(sp?.spaceName, ALL_COLORS_WITHOUT_GRAY)}
            >
              <Folder16 />
            </FolderIcon>
            <FolderName>{sp.spaceName}</FolderName>
          </Folder>
        );
      })}
    </Sidebar>
  );

  if (isResponsive) {
    return content;
  }

  return <>{!search?.trim() ? content : <></>}</>;
};
